export const SET_FOOTER_TYPE = "SET_FOOTER_TYPE";
export const CLEAR_NAVIGATION = "CLEAR_NAVIGATION";